<template>
  <div>
    <v-row
      v-if="isLoading"
      align="center"
      justify="center"
      fill-height
    >
      <v-progress-circular
        :size="125"
        :width="10"
        color="primary"
        indeterminate
      />
    </v-row>
    <v-row
      v-if="!isLoading"
    >
      <v-col cols="12" class="py-0">
        <v-card class="mb-3">
          <v-toolbar flat>
            <v-toolbar-title>
              {{ model.name }}
              <v-chip
                v-if="!model.active"
                class="mr-2"
                small
                outlined
                text
              >
                <v-icon
                  small
                  left
                >
                  archive
                </v-icon>
                ARCHIVED
              </v-chip>
            </v-toolbar-title>
            <v-spacer/>

            <v-menu
              v-model="menu"
              left
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <service-edit-dialog
                  :service="model"
                  @close="onClose()"
                  @action="onEdit"
                >
                  <template v-slot:activator="{ on }">
                    <v-list-item
                      v-on="on"
                      @click.stop=""
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-icon
                            left
                            small
                          >
                            edit
                          </v-icon>
                          Edit
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </service-edit-dialog>

                <v-list-item
                  v-if="model.active"
                  @click="onArchive()"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon
                        left
                        small
                      >
                        archive
                      </v-icon>
                      Archive
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  v-if="!model.active"
                  @click="onUnarchive()"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon
                        left
                        small
                      >
                        unarchive
                      </v-icon>
                      Unarchive
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <confirm-action
                  :model="confirmDeleteService"
                  :color="'error'"
                  :title="'Delete Service'"
                  :description="'Are you sure you want to delete this service? This can\'t be undone.'"
                  :action-text="'Delete'"
                  @cancel="confirmDeleteService = false"
                  @confirmed="onConfirmDeleteService()"
                />

                    <v-list-item
                      @click.stop="confirmDeleteService = true"
                    >
                      <v-list-item-content>
                        <v-list-item-title class="error--text">
                          <v-icon
                            left
                            small
                            color="error"
                          >
                            delete_forever
                          </v-icon>
                          Delete
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

              </v-list>
            </v-menu>
          </v-toolbar>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="5"
        class="py-0 pr-2"
      >
        <v-card class="mb-2">
          <v-toolbar flat>
            <v-toolbar-title>Details</v-toolbar-title>
          </v-toolbar>
          <v-divider/>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <info-list
                  :list="infoList"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="7"
        class="py-0 pl-2"
      >
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title>Pricing Plans</v-toolbar-title>
            <v-spacer/>
            <v-btn
              outlined
              rounded
              color="primary"
              @click="$router.push({ name: 'create-plan', params: { productId: $route.params.id }})"
            >
              <v-icon>add</v-icon>

              Add Pricing Plan
            </v-btn>
          </v-toolbar>
          <v-divider/>
          <v-card-text class="pa-0">
            <base-stripe-table
              ref="planTable"
              :headers="headers"
              :fetch-action="'listPlans'"
              :fetch-query="{ product: $route.params.id }"
              :items-getter="'getPlans'"
              :pagination-getter="'getPlanPagination'"
            >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item.id"
                  >
                    <td>
                      {{ item.nickname }}
                      <br>

                      {{ terms(item)}}
                    </td>
                    <td class="text-right">
                      <v-chip
                        v-if="!item.active"
                        class="mr-2"
                        small
                        outlined
                        text
                      >
                        <v-icon
                          small
                          left
                        >
                          archive
                        </v-icon>
                        ARCHIVED
                      </v-chip>
                      <v-progress-circular
                        v-if="isLoadingMap[item.id] === true"
                        :size="20"
                        :width="2"
                        color="primary"
                        left
                        indeterminate
                      />
                      <v-menu
                        v-if="isLoadingMap[item.id] !== true"
                        left
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            v-on="on"
                          >
                            <v-icon>more_vert</v-icon>
                          </v-btn>
                        </template>

                        <v-list dense>
                          <plan-edit-dialog
                            :plan="item"
                            @action="onEditPlan"
                          >
                            <template v-slot:activator="{ on }">
                              <v-list-item
                                v-on="on"
                                @click.stop=""
                              >
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <v-icon
                                      left
                                      small
                                    >
                                      edit
                                    </v-icon>
                                    Edit
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </plan-edit-dialog>

                          <v-list-item @click="onArchivePlan(item)">
                            <v-list-item-content>
                              <v-list-item-title>
                                <v-icon
                                  left
                                  small
                                >
                                  {{ item.active ? 'archive' : 'unarchive' }}
                                </v-icon>
                                {{ item.active ? 'Archive' : 'Unarchive' }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>

                          <confirm-action
                            :model="confirmDeletePlan"
                            :color="'error'"
                            :title="'Delete Plan'"
                            :description="'If you delete this plan, you won\'t be able to create new subscriptions to it.\n'+
'          Existing subscriptions won\'t be affected and will continue to be billed as usual until canceled. Are you sure you want to delete this plan? This can\'t be undone.'"
                            :action-text="'Delete'"
                            @cancel="confirmDeletePlan = false"
                            @confirmed="onConfirmDeletePlan(item.id)"
                          />

                          <v-list-item
                            @click.stop="confirmDeletePlan = true"
                          >
                            <v-list-item-content>
                              <v-list-item-title class="error--text">
                                <v-icon
                                  left
                                  small
                                  color="error"
                                >
                                  delete_forever
                                </v-icon>
                                Delete
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </td>
                  </tr>
                </tbody>
              </template>
            </base-stripe-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import { get } from 'lodash'
import BaseStripeTable from '@/components/Common/BaseStripeTable'
import ServiceDeleteDialog from '@/components/Service/ServiceDeleteDialog'
import ServiceEditDialog from '@/components/Service/ServiceEditDialog'
import PlanEditDialog from '@/components/Plan/PlanEditDialog'
import { readablePlanTerms } from "../../services/stripe.service"
import { getDefaultSourceFromCustomer } from '@/services/stripe.service'

import InfoList from "../Common/InfoList"
import { formatDate, isErrorResponse } from "../../services/util.service"
import ConfirmAction from "../Common/ConfirmAction"

export default {
  components: {
    ConfirmAction,
    InfoList,
    BaseStripeTable,
    ServiceDeleteDialog,
    ServiceEditDialog,
    PlanEditDialog,
  },
  data() {
    return {
      isLoading: false,
      isLoadingMap: {},
      confirmDeleteService: false,
      confirmDeletePlan: false,
      model: {},
      menu: false,
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Actions',
          align: 'right'
        }
      ]
    }
  },
  created() {
    const payload = {
      id: this.$route.params.id
    }

    this.isLoading = true
    this.getService(payload)
      .then(service => {
        this.model = { ...service }
      })
      .finally(() => {
        this.isLoading = false
      })
  },
  methods: {
    ...mapActions([ 'updateService', 'archivePlan', 'unarchivePlan', 'getService', 'deletePlan', 'deleteService' ]),
    onConfirmDeletePlan(id) {
      const payload = { id }
      this.deletePlan(payload)
        .finally(() => {
          this.confirmDeletePlan = false
          this.$refs.planTable.fetchData()
        })
    },
    onConfirmDeleteService() {
      const payload = { id: this.model.id }
      this.deleteService(payload)
        .then(res => {
          if (!isErrorResponse(res)) {
            this.$router.push({ name: 'services' })
          }
        })
        .finally(() => {
          this.confirmDeleteService = false
        })
    },
    onEditPlan() {
      this.$refs.planTable.fetchData()
    },
    terms(plan) {
      return readablePlanTerms(plan)
    },
    onEdit(data) {
      this.menu = false
      this.model = { ...data }
    },
    setIsLoadingMap(id, value) {
      this.isLoadingMap = {
        ...this.isLoadingMap,
        [ id ]: !!value
      }
    },
    async onArchivePlan(item) {
      const payload = { id: item.id }

      this.setIsLoadingMap(item.id, true)
      const plan = item.active
        ? await this.archivePlan(payload)
        : await this.unarchivePlan(payload)

      this.setIsLoadingMap(item.id, false)
    },
    onDelete(data) {
      console.log('remove service', data)
    },
    onArchive(data) {
      this.isLoading = true
      const payload = {
        id: this.model.id,
        active: false
      }
      this.updateService(payload)
        .then(service => {
          this.model = { ...service}
        })
        .finally(() => {
          this.menu = false
          this.isLoading = false
        })
    },
    onUnarchive() {
      this.isLoading = true
      const payload = {
        id: this.model.id,
        active: true
      }
      this.updateService(payload)
        .then(service => {
          this.model = { ...service}
        })
        .finally(() => {
          this.menu = false
          this.isLoading = false
        })
    },
    onClose() {
      this.menu = false
    },
    goto(id) {
      console.log('id')
    },
  },
  computed: {
    infoList() {
      return [
        {
          label: 'ID',
          value: get(this.model, 'id', '')
        },
        {
          label: 'Name',
          value: get(this.model, 'name', '')
        },
        {
          label: 'Created',
          value: formatDate(get(this.model, 'created'))
        },
        {
          label: 'Statement descriptor',
          value: get(this.model, 'statement_descriptor', '')
        }, {
          label: 'Custom unit label',
          value: get(this.model, 'unit_label', '')
        },
      ]
    }
  },
}
</script>
